import { destroy, get, getOne, post, put } from "../apis/httpClient";

export const listCategory = () => get('/api/v1/category/list')
export const pagingCategory = (params) => get('/api/v1/category/paging',params)
export const detailCategory =(query)=>getOne(`/api/v1/category/detail/${query}`)
export const updateCategory =(body)=>put(`/api/v1/category/update`,body)
export const createCategory =(body)=>post(`/api/v1/category/create`,body)
export const deleteCategory = (body) => destroy(`/api/v1/category/delete`,body)